import script from "./PageReportsWorksPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReportsWorksPlan.vue?vue&type=script&setup=true&lang=js"

import "./PageReportsWorksPlan.vue?vue&type=style&index=0&id=89269f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89269f0c"]])

export default __exports__